// src/pages/About.tsx
import React from "react";
import Container from "../components/ui/Container";
import Hero from "./Hero";
import { PrimaryButton } from "../components/ui/Buttons";

export default function About() {
    return (
        <>
            <Hero />

            {/* About Me Section */}
            <section id="about" className="py-16">
                <Container className="py-16 grid md:grid-cols-2 gap-12 items-start">
                    {/* Left content */}
                    <div>
                        <h2 className="text-3xl font-bold mb-4">About Me</h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            Hi, I'm <strong>Kalimuthu L</strong>. I’m an LIC Agent and insurance advisor, helping individuals and families find the best life and health insurance solutions.
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            My goal is to make insurance simple and ensure you feel confident and secure in your financial decisions. I specialize in life insurance, health insurance, and personalized financial planning.
                        </p>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            I look forward to helping you protect your loved ones and plan for a secure future.
                        </p>
                        <p className="text-gray-700 leading-relaxed">
                            Please feel free to reach me out in case of any queried on <strong><a href="tel:+919488114887">+91-9488114887</a></strong>.
                        </p>
                    </div>

                    {/* Right profile image */}
                    <div className="flex justify-center">
                        <img
                            src="https://i.pravatar.cc/400?img=12"
                            alt="Profile"
                            className="rounded-full shadow-md object-cover w-64 h-64"
                            onError={(e) => {
                                (e.currentTarget as HTMLImageElement).src =
                                    "https://via.placeholder.com/400x400?text=Profile";
                            }}
                        />
                    </div>
                </Container>
            </section>

            {/* Services / How I Can Help You */}
            <section className="py-16 bg-gray-50">
                <Container>
                    <h2 className="text-3xl font-bold mb-6">How I Can Help You</h2>
                    <ul className="grid md:grid-cols-3 gap-6 text-gray-700">
                        <li className="p-4 bg-white shadow rounded-lg text-center">
                            I guide you in choosing the right life insurance plan.
                        </li>
                        <li className="p-4 bg-white shadow rounded-lg text-center">
                            I help you select the best health insurance coverage for you and your family.
                        </li>
                        <li className="p-4 bg-white shadow rounded-lg text-center">
                            I provide personalized financial planning advice.
                        </li>
                        <li className="p-4 bg-white shadow rounded-lg text-center">
                            I simplify complex insurance and investment options.
                        </li>
                        <li className="p-4 bg-white shadow rounded-lg text-center">
                            I support you throughout the claims and policy process.
                        </li>
                    </ul>
                </Container>
            </section>

            {/* Testimonials (Optional) */}
            <section className="py-16 bg-white">
                <Container>
                    <h2 className="text-3xl font-bold mb-6">What My Clients Say</h2>
                    <div className="grid md:grid-cols-2 gap-6">
                        <div className="p-6 bg-gray-50 shadow rounded-lg">
                            <p className="text-gray-700 mb-2">
                                "Kalimuthu helped me choose the perfect insurance plan for my family. Highly recommend!"
                            </p>
                            <p className="font-semibold text-gray-900">– Ramesh K</p>
                        </div>
                        <div className="p-6 bg-gray-50 shadow rounded-lg">
                            <p className="text-gray-700 mb-2">
                                "Professional and trustworthy advice. Made insurance planning simple for me."
                            </p>
                            <p className="font-semibold text-gray-900">– Priya S</p>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Call to Action */}
            <section className="py-16 bg-blue-50 text-center">
                <Container>
                    <h2 className="text-3xl font-bold mb-4">Get in Touch with Me</h2>
                    <p className="text-gray-700 mb-6">
                        Reach out today to discuss your insurance and financial planning needs. I’m here to assist you personally.
                    </p>
                    <PrimaryButton onClick={() => window.location.href = "/contact"}>
                        Contact Me
                    </PrimaryButton>
                </Container>
            </section>
        </>
    );
}
